import React, { useEffect, useState, useCallback } from 'react';
import * as helper from '../../BuyboxHelper';
import { FULFILLMENT_METHOD_STH } from '../../constants';

export const useBuyBox = ({ storeZip }) => {
  const state = {
    disableATC: false,
    paypalEligible: false,
    quantity: 1,
    coverage: 0,
    fulfillmentMethod: FULFILLMENT_METHOD_STH,
    availableFulfillments: [],
    zipCode: storeZip,
    productAddOns: {
      warrantyItem: {
        itemId: null
      },
      attachedLabor: [{
        attachedLaborSku: null
      }],
      service: {
        type: null,
        selected: false,
        category: null,
      },
      subscriptions: {
        frequency: null,
        ogModule: 'pdp_nocontent'
      },
      dualPath: false,
    },
    isShowATC: false,
    showTooltip: false,
    addAdditional: true
  };
  const [buyboxState, setBuyboxState] = useState(state);

  // paypal logic
  const cartListener = useCallback((payload) => {
    const { eventName } = payload;
    if (eventName === 'success') {
      // just make paypalEligible false?
      setBuyboxState((prevState) => {
        return {
          ...prevState,
          paypalEligible: false
        };
      });
    }
  }, []);

  // paypal logic
  const checkPaypalEligible = useCallback(() => {
    const paypalEligible = helper.isPaypalEligible();
    setBuyboxState((prevState) => {
      return {
        ...prevState,
        paypalEligible
      };
    });
  }, []);
  const initializeListeners = useCallback(() => {
    window.LIFE_CYCLE_EVENT_BUS.on('add-to-cart.success', cartListener);
    window.LIFE_CYCLE_EVENT_BUS.on('select-a-store.success', cartListener);
    window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout.success', cartListener);
  }, []);

  const clearListeners = useCallback(() => {
    window.LIFE_CYCLE_EVENT_BUS.off('add-to-cart.success', cartListener);
    window.LIFE_CYCLE_EVENT_BUS.off('select-a-store.success', cartListener);
    window.LIFE_CYCLE_EVENT_BUS.off('instant-checkout.success', cartListener);
  }, []);

  // paypal logic
  useEffect(() => {
    checkPaypalEligible();
    initializeListeners();
    return function cleanup() {
      clearListeners();
    };
  }, []);

  useEffect(() => {
    if (storeZip !== buyboxState.storeZip) {
      setBuyboxState((existingState) => ({
        ...existingState,
        storeZip
      }));
    }
  }, [storeZip]);

  return [buyboxState, setBuyboxState];
};
